<template>
  <div class="tab_a">
    <div class="tab_check">
      <el-checkbox-group v-model="checkList" @change="ChanegeCheckGroup">
        <el-checkbox label="1">全选男上装</el-checkbox>
        <el-checkbox label="2">全选男下装</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="Size_box">
      <table border="0" cellspacing="0" class="hcp_table">
        <thead>
          <tr>
            <th>男士身高(cm)</th>
            <th colspan="2">上装</th>
            <th colspan="2">下装</th>
          </tr>
        </thead>
        <tbody class="table_tbody">
          <tr v-for="(item,key,index) in DataList" :key="index">
          <td class="size_cm">{{key}}</td>
          <td class="size_td">
            <div v-for="(x,ind) in item.UP" :key="ind">
                <span @click="ChangeSize(x)" :class="{'active_size':filterSizeActive(x),'size_child':true,'size_last_child':ind/2===(item.UP.length/2)-1}" v-if="ind%2===0">
                  {{x.typeValue}}
                </span>
            </div>
          </td>
            <td class="size_td">
              <div v-for="(x,ind) in item.UP" :key="ind">
                <span @click="ChangeSize(x)" :class="{'active_size':filterSizeActive(x),'size_child':true,'size_last_child':ind===item.UP.length-1}" v-if="ind%2===1">
                  {{x.typeValue}}
                </span>
              </div>
            </td>
          <td class="size_td">
            <div v-for="(x,ind) in item.DOWN" :key="ind">
                <span @click="ChangeSize(x)" :class="{'active_size':filterSizeActive(x),'size_child':true,'size_last_child':ind/2===(item.DOWN.length/2)-1}" v-if="ind%2===0">
                  {{x.typeValue}}
                </span>
            </div>
          </td>
          <td class="size_td">
            <div v-for="(x,ind) in item.DOWN" :key="ind">
                <span @click="ChangeSize(x)" :class="{'active_size':filterSizeActive(x),'size_child':true,'size_last_child':ind===item.DOWN.length-1}" v-if="ind%2===1">
                  {{x.typeValue}}
                </span>
            </div>
          </td>
        </tr>
        </tbody>

      </table>
    </div>
  </div>
</template>

<script>
import SizeMixins from './mixin'
export default {
  name: "MensWear",
  mixins:[SizeMixins],
  props:{
    DataList:{
      type: Object,
      default: ()=>{}
    },
  },
  data(){
    return {
      checkList:[],
      SizeObj:[],
    }
  },
  mounted() {
    this.EchoSizeData('MensWear')
  },
  methods:{
    ChangeSize(x){
      if(x.typeId) {
        this.StorageSizeData(x, 'MensWear')
      }
    },
    ChanegeCheckGroup(val){
      this.SelectAllSizeTab(val,'MensWear')
    }
  }
}
</script>

<style scoped lang="scss">
table {
  border: none;
  padding: 0;
  margin:0;
}
tr,td{
  padding: 0;
  margin:0;
}
table tbody{
  display: block;
  height: 300px;
  overflow-y: auto;
  text-align: center;
  -webkit-overflow-scrolling: touch;
}
table thead,
tbody tr{
  display: table;
  width: 100%;
  table-layout: fixed;
}
.Size_box{
  margin-top: 10px;
  width: 850px;
  .hcp_table{
    border-spacing: 0;
    border: 1px solid #cccccc;
    background:rgb(246,246,246);
    thead{
      width: calc(100% - 17px);
    }
    tbody tr:last-child td{
      border-bottom: none;
    }
    tbody tr td:last-child{
      border-right: none;
    }
    tr{
      background: #FFFFFF;
    }
    th{
      background: #F6F6F6;
      font-size: 14px;
    }
    td{
      cursor: pointer;
      vertical-align: baseline;
      font-size: 14px;
      .ts_size_box:last-child{
        .size_child{
          border-bottom: none;
        }

      }
      .size_last_child{
        border-bottom: none !important;
      }
    }
    tr{
      .size_child{
        height: 45px;
        line-height: 45px;
        border-bottom: 1px solid #ccc;
        display: block;
      }
      .size_cm{
        vertical-align: middle;
      }
    }
    th,td{
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      text-align: center;
      min-width: 120px;
      height: 45px;
    }
  }
}
.active_size{
  background-color: #FAECE6;
  color: #000000;
}
</style>